// import { Button, Drawer, Skeleton, Checkbox, TreeSelect, Card, Spin } from "antd";
// import { useState, useEffect } from "react";
// import ReactApexChart from "react-apexcharts";

import { useEffect, useRef, useState } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { Button, Card, Skeleton } from "antd";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import * as echarts from 'echarts';
import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";


// import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
// import CustomDrawer from "../../../../../Elements/CustomDrawer";
// import CustomSelect from "../../../../../Elements/CustomSelect";
// import SteamTreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
// import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";
// import { APIConstants } from "../../../../../../Common/APIConstants";
// import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";
// import { useSelector } from "react-redux";
 
// const AirLiveChart = () => {
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const [sectionId, setSectionId] = useState();
//   const [converterGroupId, setConverterGroupId] = useState();
//   const [selectedMeterIds, setSelectedMeterIds] = useState();
//   const [selectedValues, setSelectedValues] = useState([]);
//   const [skip, setSkip] = useState(true);
//   const [open, setOpen] = useState(false);
//   const [seriesChartData, setSeriesChartData] = useState();
//   const [chartTime, setChartTime] = useState();
//   const [singleMeterName, setSingleMeterName] = useState();
//   const [sectionError, setSectionError] = useState();
//   const [converterError, setConverterError] = useState();
//   const [meterError, setMeterError] = useState();
//   const [paraError, setParaError] = useState();
//   const [chartSkip, setChartSkip] = useState(true);  
//   const [chartInput, setChartInput] = useState();
//   const [submitClicked, setSubmitClicked] = useState(false);
//   const [flowSectionList, setFlowSectionList] = useState([]);
//   const [flowConverterList, setFlowConverterList] = useState([]);
//   const [flowGroupDetailList, setFlowGroupDetailList] = useState([]);
//   const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [steamGroupMeterList, setSteamGroupMeterList] = useState([]);

//   const [steamConverterLiveChartData, setSteamConverterLiveChartData] =
//     useState([]);
//     const mode = useSelector((state) => state.darkMode);

//     const { isdarkMode } = mode;

//   const showDrawer = () => {
//     setOpen(true);
//   };

//   const onClose = () => {
//     setOpen(false);
//   };

//   const [chartData, setChartData] = useState({
//     series: [
//       {
//         name: "",
//         data: [],
//       },
//     ],

//     options: {
//       chart: {
//         height: 350,
//         type: "line",
//         zoom: {
//           type: "x",
//           enabled: true,
//           // autoScaleYaxis: true,
//         },
//         animations: {
//           enabled: true,
//           easing: "linear",
//           dynamicAnimation: {
//             speed: 1,
//           },
//         },
//         toolbar: {
//           autoSelected: "zoom",
//         },
//       },
//       legend: {
//         show: true,
//         showForSingleSeries: true,
//         showForNullSeries: false,
//         showForZeroSeries: true,
//         position: "bottom",
//         horizontalAlign: "center",
//         floating: false,
//         fontSize: "14px",
//         fontFamily: "Helvetica, Arial",
//         fontWeight: 400,
//         formatter: undefined,
//         inverseOrder: false,
//         width: undefined,
//         height: undefined,
//         tooltipHoverFormatter: undefined,
//         customLegendItems: [],
//         offsetX: 0,
//         offsetY: 0,
//         labels: {
//           colors: undefined,
//           useSeriesColors: false,
//         },
//         markers: {
//           width: 12,
//           height: 12,
//           strokeWidth: 0,
//           strokeColor: "#fff",
//           fillColors: undefined,
//           radius: 12,
//           customHTML: undefined,
//           onClick: undefined,
//           offsetX: 0,
//           offsetY: 0,
//         },
//         itemMargin: {
//           horizontal: 5,
//           vertical: 10,
//         },
//         onItemClick: {
//           toggleDataSeries: true,
//         },
//         onItemHover: {
//           highlightDataSeries: false,
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: "smooth",
//       },
//       markers: {
//         size: 5,
//         sizeOffset: 0,
//         hover: {
//           size: undefined,
//           sizeOffset: 3,
//         },
//       },
//       // title: {
//       //   text: "Live Trends Chart",
//       //   align: "left",
//       // },

//       // xaxis: {
//       //   categories: [],
//       //   labels: {
//       //     format: "dd-MMM",
//       //   },
//       //   title: {
//       //     text: "Date",
//       //   },
//       // },
//       title: {
//         // display: true,
//         text: "Live Trends Chart",
//         // color:  'red',

//         style: {
//    color: isdarkMode ? "#FFFFFF" : "#000000",
//               // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
//            fontSize: "18px", 
//            fontWeight: "bold" },
        
//       },
//       xaxis: {
//         categories: [],
//         labels: { 
//           style: { 
//             color: "red",
//           }
//         },
//         title: { 
//           text: "Date", 
//           style: {
//             color: isdarkMode ? "#FFFFFF" : "#000000",
//           }
//         }
//       },
//       yaxis: {
//         title: {
//           text: "Value",
//         },
//       },
//       tooltip: {
//         x: {
//           show: true,
//           format: "dd MMM",
//           formatter: undefined,
//         },
//         y: {
//           title: {
//             formatter: (
//               seriesName,
//               { series, seriesIndex, dataPointIndex, w }
//             ) => {
//               const isFlowRate = seriesName.includes("flowRate");
//               const kgLabel = isFlowRate ? " Kg/hr" : "Kg";

//               // Assuming opts.value contains the actual y-axis value
//               return seriesName + kgLabel;
//             },
//           },
//         },
//       },
//     },
//   });

//   //   GetsteamConverterLiveChart?SectionID=1&ConverterorGroupID=1&MeterIds=1&FromDate=2023-10-27%2007%3A15%3A00.000&Todate=2023-10-28%2007%3A15%3A00.000  

//   const fetchSteamConverterLive = (input) => {
//     const url = `${APIConstants.GET_LIVE_CHART_AIR}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;

    
//     console.log(url);

//     makeRequest({
//       type: APIConstants.GET,
//       url: url,
//     }).then((res) => {
//       if (res.length>0) {
//         setSteamConverterLiveChartData(res);
//       }
//       setIsLoading(false)
//       console.log(res);
//     });
//   };



//   useEffect(() => {
//     if (chartInput) {
//         fetchSteamConverterLive(chartInput);
//     }
//   }, [chartInput]);

// //to fetch meter upon converter selection 
//   const fetchNsFlow= (id) => {
//     makeRequest({
//       type: APIConstants.GET,

//       url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${id}`
//     }).then((res) => {
//       console.log(res)
//       setNsFlowConverterList(res);
//     });
//   };

  
//   useEffect(() => {
//     if (converterGroupId) {
//       fetchNsFlow(converterGroupId);
//     }
//   }, [converterGroupId]);



//   //to fetch metrs upon group selection
//   const fetchGroupMeter= (id) => {
   
//     makeRequest({
//       type: APIConstants.GET,
//       // GetFlowSteamGropeMeterDetails?GroupID=81
//       url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${id}`
//     }).then((res) => {
//       console.log(res)
//       setSteamGroupMeterList(res);
//     });
//   };

  
//   useEffect(() => {
//     if (converterGroupId) {
//       fetchGroupMeter(converterGroupId);
//     }
//   }, [converterGroupId]);



//   useEffect(() => {
//     makeRequest({
//       type: APIConstants.GET,
//       url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
//     }).then((res) => {
//         console.log(res)
//       setFlowSectionList(res);
//     });


// makeRequest({
//       type: APIConstants.GET,

//       url: APIConstants.GET_FLOW_CONVERTER_DETAILS,
//     }).then((res) => {
//       console.log(res)
//       setFlowConverterList(res);
//     });

// makeRequest({
//       type: APIConstants.GET,

//       url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
//     }).then((res) => {
//       console.log(res)
//       setFlowGroupDetailList(res);
//     });

    

//   },[]);

//   useEffect(() => {
//     // After 1 second, set skipValue to false
//     const timeoutId = setTimeout(() => {
//       setSkip(false);
//     }, 3000);

//     // Clear the timeout if the component unmounts or skipValue is set to false
//     return () => clearTimeout(timeoutId);
//   }, []);

//   const setChartInputData = () => {
//     localStorage.setItem("secId", Number(sectionId || 1));
//     localStorage.setItem("ConverterorGroupID", Number(converterGroupId || 24));
//     localStorage.setItem("meterIds", JSON.stringify(selectedMeterIds || ["21,22"]));
//     localStorage.setItem(
//       "parameters",
//       JSON.stringify(selectedValues || ["flowRate"])
//     );

//     const currentDate = new Date();
//     // console.log(currentDate)
//     const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
//     // console.log(from ,to)
//     // console.log(currentDate)

//     const lgSecId = localStorage.getItem("secId");
//     const lgConvId = localStorage.getItem("ConverterorGroupID");
//     const meterId = localStorage.getItem("meterIds");

//     const inputIds = JSON.parse(meterId).map((item) => item);
//     const ids = inputIds?.map((id) => id).join(",");

//     const inputData = {
//       SectionID: Number(lgSecId),
//       ConverterorGroupID: Number(lgConvId),
//       MeterIds: ids,
//       FromDate: from || '2023-10-27 10:40:08.533 ',
//       ToDate: to ||  '2023-10-28 06:12:37.670',
//     };
// console.log(inputData)
//     const queryString = (inputData);
//     setChartInput(queryString);
//   };

//   const handleChangeSection = (changedValues) => {
//     setSectionId(changedValues);
//     setSelectedMeterIds();
//     setSubmitClicked(false);
//     if (changedValues) {
//       setSectionError("");
//     }
//   };

//   const handleChangeConverterGroup = (changedValues) => {
//     console.log(changedValues)
//     setConverterGroupId(changedValues);
//     setSelectedMeterIds();
//     setSubmitClicked(false);
//     if (changedValues) {
//       setConverterError("");
//     }
//   };

//   const handleMeterChange = (selectedValues) => {
//     setSelectedMeterIds(selectedValues);
//     setSubmitClicked(false);
//     if (selectedValues) {
//       setMeterError("");
//     }
//   };

//   const handleTreeChange = (values) => {
//     setSelectedValues(values);
//     setSubmitClicked(false);
//     if (values) {
//       setParaError("");
//     }
//   };

//   useEffect(() => {
//     setChartInputData();
//   }, []);

//   const updateChart = async (data) => {
//     const meterId = localStorage.getItem("meterIds");
//     const inputIds = JSON.parse(meterId)?.map((item) => item);

//     // filter data based on selected meters
//     const filterMeterData = () => {
//       const selectedMeterData = steamConverterLiveChartData?.filter((item) =>
//         inputIds?.map((id) => Number(id)).includes(item?.meterid)
//       );
//       return selectedMeterData;
//     };

//     // transform the data in a chart series format
//     const transformData = (property, meterName) => {
//       const data = filterMeterData()
//         ?.filter((item) => item?.metername === meterName)
//         ?.map((item) => item[property]);
//       data?.reverse();

//       const seriesData = {
//         name: `${property}-${meterName}`, // Concatenate property and METERNAME
//         data,
//       };

//       return seriesData;
//     };

//     const getChartSeriesData = () => {
//       const properties = selectedValues?.length ? selectedValues : ["flowRate"];
//       const seriesDataArray = [];

//       // Iterate over selected meter IDs and properties
//       inputIds?.forEach((id) => {
//         const meterName = filterMeterData()?.find(
//           (item) => item?.meterid === Number(id)
//         )?.metername;

//         properties.forEach((property) => {
//           seriesDataArray.push(transformData(property, meterName));
//         });
//       });
//       return seriesDataArray;
//     };

//     const getChartDate = () => {
//       const dateArray = [];
//       const date = ["createdON"];
//       inputIds?.forEach((id) => {
//         const meterName = filterMeterData()?.find(
//           (item) => item?.meterid === Number(id)
//         )?.metername;

//         date?.forEach((property) => {
//           dateArray.push(transformData(property, meterName));
//         });
//       });
//       // Find the array with the maximum length
//       const longestArray = dateArray.reduce((maxArray, currentArray) => {
//         return currentArray?.data?.length > maxArray?.data?.length
//           ? currentArray
//           : maxArray;
//       }, dateArray[0] || []);
//       return longestArray?.data?.reverse();
//     };

//     const finalSeriesData = () => {
//       const firstOption = selectedValues?.includes("flowRate");
//       const secondOption = selectedValues?.includes("cumulative");

//       const finalData = getChartSeriesData()?.filter((series) => {
//         if (firstOption && secondOption) {
//           // Both options selected, keep all series
//           return true;
//         } else if (firstOption) {
//           // First option selected, add series with "FlowRate"
//           return series.name.includes("flowRate");
//         } else if (secondOption) {
//           // Second option selected, add series with "Cumulative"
//           return series.name.includes("cumulative");
//         }
//         // If neither option selected, keep all series
//         return true;
//       });
//       return finalData;
//     };

//     const reversedDate = getChartDate();
//     const localDateTime = reversedDate?.map((date) =>
//       new Date(date).toLocaleString()
//     );

//     const finalSeries = finalSeriesData();
//     setSingleMeterName(finalSeries[0]?.name);

//     setSeriesChartData(finalSeries);
//     setChartTime(localDateTime);
//   };

//   useEffect(() => {
//     setChartSkip(false);
//     updateChart();
//     const interval = setInterval(() => {
//       // refetchChart();
//       updateChart();
//     }, [600000]);

//     return () => {
//       clearInterval(interval);
//     };
//   }, [chartInput, steamConverterLiveChartData, selectedValues]);

//   useEffect(() => {
//     if (!steamConverterLiveChartData) {
//       updateChart();
//     }
//   }, [steamConverterLiveChartData]);

//   useEffect(() => {
//     setChartData((prevChartData) => ({
//       series: seriesChartData || [],
//       options: {
//         ...prevChartData.options,
//         xaxis: {
//           ...prevChartData.options.xaxis,
//           categories: chartTime ? chartTime.reverse() : [],
//         },
//         yaxis: {
//           title: {
//             text: selectedValues.join(",".toString()),
//           },
//         },
//       },
//     }));
//   }, [seriesChartData, chartTime]);

//   const parameters = [
//     { id: 1, name: "flowRate" },
//     { id: 2, name: "cumulative" },
//   ];

//   const isInvalid = singleMeterName?.split("-");

//   const validateInput = (value, label) => {
//     const error = !value ? `Please Select ${label}` : "";
//     return error;
//   };

//   const handleSubmit = () => {
//     const sectionError = validateInput(sectionId, "Section");
//     const converterError = validateInput(converterGroupId, "Converter");
//     const meterError = validateInput(selectedMeterIds, "Meter");
//     const paraError = validateInput(selectedValues, "Parameter");

//     setSectionError(sectionError);
//     setConverterError(converterError);
//     setMeterError(meterError);
//     setParaError(paraError);

//     if (!sectionError && !converterError && !meterError && !paraError) {
//       setChartInputData();
//       setSubmitClicked(true);
//       setIsLoading(false);
//       onClose();
//     }
//   };

//   useEffect(() => {
//     const timer = setInterval(() => {
//       if (
//         submitClicked &&
//         converterGroupId &&
//         sectionId &&
//         selectedMeterIds?.length &&
//         selectedValues?.length
//       ) {
//         setChartInputData();
//       }
//     }, 10000);
//     return () => clearInterval(timer);
//   }, [
//     converterGroupId,
//     sectionId,
//     selectedMeterIds,
//     submitClicked,
//     selectedValues,
//   ]);

//   return (
//     <div id="chart" className = {`relative p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
//          {isLoading  &&(
//         <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
//           <Spin active paragraph={{ rows: 6 }} />
//         </div>
//       )}

//       <Card
//         className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
//         style={{ position: 'relative', overflow: 'hidden' }}
//       >
//         <ReactApexChart
//           options={chartData.options}
//           series={chartData.series}
//           type="line"
//           height={500}
//           className="w-full"
//         />


//         {seriesChartData?.length === 1 && isInvalid[1] !== "undefined" && (
//           <p className="text-center ml-16">{singleMeterName}</p>
//         )}
//       </Card>

     
//       <CustomDrawer
//         title="Close"
//         showDrawer={showDrawer}
//         open={open}
//         onClose={onClose}
//       >
//         <div className="flex flex-col space-y-2">
//           <CustomSelect
//             label="Section:"
//             options={flowSectionList}
//             onSelect={handleChangeSection}
//             valueKey="sectionID"
//             nameKey="sectionName"
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {sectionError}
//           </small>
//           <CustomSelect
//             label="Converter / Group:"
//             options={
//               sectionId === 1 ? flowConverterList : flowGroupDetailList
//             }
//             onSelect={handleChangeConverterGroup}
//             valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
//             nameKey={sectionId === 1 ? "sitename" : "groupName"}
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {converterError}
//           </small>
//           <SteamTreeSelectCustomWithSelectAll
//             label="Meters:"
//             data={
//               sectionId === 1
//                 ? nsFlowConverterList
//                 : steamGroupMeterList
//             }
//             idKey={sectionId === 1 ? "meterid" : "meterID"}
//             valueKey={sectionId === 1 ? "meterid" : "meterID"}
//             nameKey={sectionId === 1 ? "metername" : "meterName"}
//             selectedValues={selectedMeterIds}
//             setSelectedValues={setSelectedMeterIds}
//             onSelect={handleMeterChange}
//           />

//           <small className="text-red-500 font-bold ml-[150px]">
//             {meterError}
//           </small>

//           <SteamTreeSelectCustom
//             label="Parameters:"
//             data={parameters}
//             idKey="id"
//             nameKey="name"
//             valueKey="name"
//             selectedValues={selectedValues}
//             setSelectedValues={setSelectedValues}
//             onSelect={handleTreeChange}
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {paraError}
//           </small>
//         </div>
//         <div className="flex justify-center mt-4">
//           <Button
//             className="blue-btn"
//             onClick={() => {
//               handleSubmit();
//             }}
//           >
//             Search
//           </Button>
//         </div>
//       </CustomDrawer>
//     </div>
//   );
// };

// export default AirLiveChart;



const AirLiveChart = () => {
  const chartRef = useRef(null); 
  const chartInstance = useRef(null); 
  const {loading,  makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();

  const [chartLoading, setChartLoading] = useState(false);

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter,setParameter]=useState([]);
  const [data1,setData1]= useState([]);
  const [data2,setData2]= useState([]);
  const [data3,setData3]= useState([]);
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
      });

    makeRequest({  
        type: APIConstants.POST, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });

      // makeRequest({  
      //   type: APIConstants.GET, 
      //   url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
      // }).then((res) => {
      //   console.log(res)
      //   setParameter(res);
      // });

  },[])

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}` 
        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.POST,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId])

  
  function transformDatas(inputData) {
    // Initialize arrays to store unique CreatedOn values and unique meter names
    const createdOn = [];
    const meterNames = [];
    console.log(inputData);
    
    // Collect unique CreatedOn values and meter names
    inputData.forEach(entry => {
      const formattedDate = entry.createdON.replace("T", " ");
      if (!createdOn.includes(formattedDate)) {
        createdOn.push(formattedDate);
      }
      if (!meterNames.includes(entry.METERNAME)) {
        meterNames.push(entry.METERNAME);
      } 
    });
  
    // Initialize series array with meter names
    const series = meterNames.map(meterName => ({
      name: meterName,
      type: 'line',
      stack: 'Total',
      data: Array(createdOn.length).fill(0) // Initialize with zeros for each CreatedOn value
    }));
  
    inputData.forEach(entry => {
      const formattedDate = entry.createdON.replace("T", " ");
      const dateIndex = createdOn.indexOf(formattedDate);
      const meterIndex = meterNames.indexOf(entry.METERNAME);
  
      if (dateIndex !== -1 && meterIndex !== -1) {
        series[meterIndex].data[dateIndex] += entry.KWHTotal;
      }
    });
  
    // Return the formatted structure
    return { series, createdOn, meterNames };
  }
  



function prepareLineChartData(data, excludeFields = ["sitename", "meterid", "createdON", "metername"]) {
  const series = [];
  const xAxisData = [];
  const metrics = {};
  const parameters=[];
  
  function removeDuplicates(inputArray) {
    const seen = new Set();
    const result = [];
    
    inputArray.forEach(item => {
      if (!seen.has(item)) {
        result.push(item); 
        seen.add(item);
      }
    });
     
    return result;
  }

  data.forEach((entry) => {
      // Add unique timestamps to x-axis  
      if (!xAxisData.includes(entry.createdON.replace("T", " "))) {
          xAxisData.push(entry.createdON.replace("T", " ")); 
      }

      // Iterate through all fields in the entry
      for (const key in entry) {
          if (!excludeFields.includes(key)) {
              // Group by METERNAME and metric (e.g., KWHTotal)
              const metricKey = `${entry.metername}-${key}`;
              if (!metrics[metricKey]) {
                  metrics[metricKey] = [];
              }
              metrics[metricKey].push(entry[key]);
              parameters.push(key);

          }
      }
  });

  // Prepare series for ECharts
  for (const [metricName, values] of Object.entries(metrics)) {
      series.push({
          name: metricName,
          type: 'line',
          data: values,
      });
  }
  const para = removeDuplicates(parameters)
  console.log(para)
  console.log(xAxisData)

  return {
      xAxisData:xAxisData,
      series: series,
      parameter:para 
  };  
}

  const parameters = [
    { id: 1, name: "flowRate" },
    { id: 2, name: "cumulative" },
  ];
  
  const getResponse =(inputData)=>{
    console.log(inputData)
    setIsLoading(true)
     
    makeRequest({ 
        type: APIConstants.GET,    
        // url: `${APIConstants.GET_LIVE_CHART_AIR}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}` 
        url: `${APIConstants.GET_LIVE_CHART_AIR}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=75&Parameters=${inputData.Parameters}&FromDate=2023-09-21 12:06:43&Todate=2023-09-21 12:07:43` 
        // url :`http://20.244.40.160:81/api/Air/GetAirLivechart?SectionID=1&ConverterorGroupID=21&MeterIds=75%2C76%2C77&FromDate=2023-10-01%2000%3A00%3A00&Todate=2023-10-01%2002%3A00%3A00`
      }).then((res) => {
        console.log(res)
        if (res&&res.length>0) {    
          setsteamHistoricalData(res);
          const data = transformDatas(res);
          console.log(data)
          console.log(data.meterNames)
          // setData1(data.createdOn) 
          // setData2(data.series)
          // setData3(data.meterNames)
          const test =prepareLineChartData(res)
          console.log(test)
          setData1(test.xAxisData)
          setData2(test.series)
          // setData3(test.parameter)
        }
        setIsLoading(false)
      });
  }

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    localStorage.setItem('flowSectionResData', JSON.stringify(changedValues));
    setSectionId(changedValues);
    // setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    console.log(changedValues);
    setConverterGroupId(changedValues);
    localStorage.setItem('converterGroupId', JSON.stringify(changedValues));

    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);

    localStorage.setItem('selectedMeterIds', JSON.stringify(selectedValues));
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    localStorage.setItem('selectedValues', JSON.stringify(values));

    if (values) {
      setParaError("");
    } 
  };

  const setChartInputData = () => {
    
    const sectionId =localStorage.getItem('flowSectionResData');
    console.log(sectionId)
    const converterGroupId =localStorage.getItem('converterGroupId');
    console.log(converterGroupId)
    const selectedValue =localStorage.getItem('selectedValues');
    console.log(selectedValue)
    const para = JSON.parse(selectedValue)?.map((id) => id).join(",");
    console.log(para)
    const selectedMeterIds =localStorage.getItem('selectedMeterIds');
    console.log(selectedMeterIds)
    const ids = JSON.parse(selectedMeterIds)?.map((id) => id).join(",");
    console.log(ids)
    setSelectedMeterIds(JSON.parse(selectedMeterIds))
    setSelectedValues(JSON.parse(selectedValue))
    // const ids = selectedMeterIds?.map((id) => id).join(",");
    


    const currentDate = new Date();
    console.log(currentDate)
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    console.log(from,to)

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 0,
      Parameters:para||0,
      MeterIds: ids || [],
      FromDate: from,
      ToDate: to,
    };
    console.log(inputData)
    getResponse(inputData)
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };


  useEffect(() => {
    // Call the function every minute
    const interval = setInterval(() => {
      setChartInputData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Cleanup the interval when the component unmounts
    return () => clearInterval(interval);
  }, []); // Empty dependency array ensures this runs once on mount

  useEffect(() => {
    setChartSkip(!chartSkip);  
    // updateChart();
  },[steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError 
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(true); 
    }
  };

  

  // useEffect(() => {
  //   if (loading || !data1 || !data2) return; // Prevent chart rendering if loading or data is unavailable
  
  //   console.log(data1);
  //   console.log(data2);
  
  //   const myChart = echarts.init(chartRef.current);
  
  //   const option = {
  //     backgroundColor: isdarkMode ? '#2d3748' : '#fff',
  //     title: {
  //       text: `Live Trends`,
  //       left: 'center',
  //       top: '5px',  
  //       textStyle: {
  //         color: isdarkMode ? 'white' : 'black',
  //       },
  //     },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: {
  //         type: 'shadow',
  //       },
  //     },
  //     legend: {
  //       // data: data3,
  //       bottom: '0px',
  //       textStyle: {
  //         color: isdarkMode ? 'white' : 'black',
  //       },
  //     },
  //     grid: {
  //       left: '3%',
  //       right: '4%',
  //       bottom: '25%',
  //       containLabel: true,
  //     },
  //     toolbox: {
  //       show: true,
  //       orient: 'horizontal',
  //       left: 'right',
  //       top: 'top',
  //       feature: {
  //         mark: { show: true },
  //         magicType: { show: true, type: ['line', 'bar'] },
  //         saveAsImage: { show: true },
  //       },
  //     },
  //     xAxis: [
  //       {
  //         type: 'category',
  //         axisTick: { show: false },
  //         data: data1,
  //         axisLabel: {
  //           color: isdarkMode ? 'white' : 'black',
  //           fontSize: '10',
  //           fontWeight: 'bold',
  //         },
  //       },
  //     ],
  //     yAxis: [
  //       {
  //         type: 'value',
  //         axisLabel: {
  //           color: isdarkMode ? 'white' : 'black',
  //           fontSize: '10',
  //           fontWeight: 'bold',
  //         },
  //       },
  //     ],
  //     series: data2,
  //   };
  
  //   myChart.setOption(option);
  
  //   const resizeHandler = () => myChart.resize();
  //   window.addEventListener('resize', resizeHandler);
  
  //   return () => {
  //     window.removeEventListener('resize', resizeHandler);
  //     myChart.dispose();
  //   };
  // }, [data1, data2, isdarkMode, loading]); // Include loading in dependencies
    useEffect(() => {
      if (loading || !data1 || !data2) return; // Prevent chart rendering if data is unavailable
    
      const totalPoints = 15; // Total number of points in the input data
      const maxVisiblePoints = 10; // Maximum points to show on the chart
      let currentIndex = maxVisiblePoints; // Start updating from the next point
    
      // Prepare initial data
      let visibleXAxisData = data1.slice(0, maxVisiblePoints);
      let visibleSeriesData = data2.map((series) => ({
        ...series,
        data: series.data.slice(0, maxVisiblePoints),
      }));
    
      // Initialize chart instance
      if (!chartInstance.current) {
        chartInstance.current = echarts.init(chartRef.current);
      }
    
      // Set initial chart options
      const initialOptions = {
        backgroundColor: isdarkMode ? '#2d3748' : '#fff',
        title: {
          text: 'Live Trends',
          left: 'center',
          top: '5px',
          textStyle: {
            color: isdarkMode ? 'white' : 'black',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          confine: true,
          position: function (point, params, dom, rect, size) {
            const [x, y] = point;
            const { contentSize, viewSize } = size;
            let xPos = x + 10;
            let yPos = y + 10;
    
            if (xPos + contentSize[0] > viewSize[0]) {
              xPos -= contentSize[0] + 20;
            }
            if (yPos + contentSize[1] > viewSize[1]) {
              yPos -= contentSize[1] + 20;
            }
    
            return [xPos, yPos];
          },
        },
        legend: {
          bottom: '0px',
          textStyle: {
            color: isdarkMode ? 'white' : 'black',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '25%',
          containLabel: true,
        },
        toolbox: {
          show: true,
          orient: 'horizontal',
          left: 'right',
          top: 'top',
          feature: {
            mark: { show: true },
            magicType: { show: true, type: ['line', 'bar'] },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: visibleXAxisData,
            axisLabel: {
              color: isdarkMode ? 'white' : 'black',
              fontSize: '10',
              fontWeight: 'bold',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: isdarkMode ? 'white' : 'black',
              fontSize: '10',
              fontWeight: 'bold',
            },
          },
        ],
        series: visibleSeriesData,
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
        ],
      };
    
      chartInstance.current.setOption(initialOptions);
    
      // Update chart data every 15 seconds
      const updateData = () => {
        if (currentIndex < totalPoints) {
          // Remove the first value and add the next value
          visibleXAxisData.shift();
          visibleXAxisData.push(data1[currentIndex]);
    
          visibleSeriesData = visibleSeriesData.map((series, idx) => {
            const updatedData = [...series.data];
            updatedData.shift(); // Remove the first value
            updatedData.push(data2[idx].data[currentIndex]); // Add the new value
            return { ...series, data: updatedData };
          });
    
          // Update the chart with the new data
          chartInstance.current.setOption({
            xAxis: [
              {
                data: visibleXAxisData,
              },
            ],
            series: visibleSeriesData,
          });
    
          currentIndex++;
        } else {
          // Stop updating after all points are used
          console.log('All data has been added. Stopping updates.');
          clearInterval(interval);
        }
      };
    
      // Set interval to update every 15 seconds
      const interval = setInterval(updateData, 13000);
    
      // Handle window resize
      const resizeHandler = () => chartInstance.current.resize();
      window.addEventListener('resize', resizeHandler);
    
      return () => {
        clearInterval(interval); // Clear interval on cleanup
        window.removeEventListener('resize', resizeHandler);
        chartInstance.current.dispose();
        chartInstance.current = null;
      };
    }, [data1, data2, isdarkMode]);

  return (
    <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
      {/* {isLoading  &&(
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div> 
      )} */}
     
      <Card
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode" } w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative', overflow: 'hidden' }}
        bordered={false}
      >  

{
          !data1.length >0 && !loading &&
          <div className="text-3xl">
          <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          </div> 
         }  
          {loading  && loadings && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
        <div ref={chartRef} className={`${(!loading||!loadings) && data1.length>0 ? 'min-h-[650px]':'h-0'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>

        </Card>


        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "department"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId == 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={ "meterid"}
            valueKey={ "meterid"}
            nameKey={ "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          {/* <TreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"        
            nameKey="name"     
            valueKey="name"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          /> */}
            <SteamTreeSelectCustom
             label="Parameters:"
             data={parameters}
             idKey="id"
             nameKey="name"
             valueKey="name"
             selectedValues={selectedValues}
             setSelectedValues={setSelectedValues}
             onSelect={handleTreeChange}
           />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            
            {/* {parameterLenght} */}
          </small>
         
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button> 
        </div>
      </CustomDrawer>
    </div>
  );
};

export default AirLiveChart;
